import { Component, OnInit, Input, ViewChild, Output, EventEmitter  } from '@angular/core';
import { ReportMetadata, ReportSchedule, ReportState, ReportYear, ReportCategory, Report, ReportStates, ReportAuditRecord } from '../../../models/report.model';
import { ReportService } from '../../../services/report.service';
import { LookupService } from '../../../services/lookups/lookup.service';
import { NotifierService } from 'angular-notifier';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ViewHistoryComponent } from '../view-history/view-history.component';
import { RptmetadataComponent } from '../rptmetadata/rptmetadata.component';
import { ReportdashboardService } from '../../../services/reportdashboard.service';
import { environment } from '../../../../environments/environment';
import { ViewAttachmentComponent } from '../view-attachment/view-attachment.component';

@Component({
  selector: 'app-rptstatusmgmt',
  templateUrl: './rptstatusmgmt.component.html',
  styleUrls: ['./rptstatusmgmt.component.css'],
  providers: [ConfirmationService]
})
export class RptstatusmgmtComponent implements OnInit {
  @ViewChild(ViewHistoryComponent) viewHistory: ViewHistoryComponent;
  ReportYears: ReportYear[];
  @Input() ReportYear: ReportYear;
  displayStatusDlg: boolean;
  displayMetadata = false;
  reportData: Report[];
  allReportStates: ReportState[];
  reportNames: SelectItem[];
  countries: SelectItem[];
  fasPosts: SelectItem[];
  reportNumbers: SelectItem[];
  distributionTypes: SelectItem[];
  reportStates: SelectItem[];
  reportTypes: SelectItem[];
  lstReportStates: SelectItem[];
  selectedState: SelectItem;
  reportId: any;
  displayHistoryDlg: boolean = false;
  publishedReportMetadata: ReportMetadata;
  showPublishedReportClick: boolean = false;
  reportScheduleforStatus: ReportSchedule;
  displayAttachmentDlg: boolean = false;

  @ViewChild(RptmetadataComponent) RptMetadata: RptmetadataComponent;
  @ViewChild(ViewAttachmentComponent) viewAttachment: ViewAttachmentComponent;
  constructor(private reportService: ReportService,
    private reportDashboardService: ReportdashboardService,
    private lookupService: LookupService,
    private notifier: NotifierService,
    private confirmationService: ConfirmationService) { }

  ngOnInit() {

    this.getReportYears();
    this.loadReportStates(-1); //include all states
    this.loadReportsTable(this.ReportYear.year);
    this.displayAttachmentDlg = false;

  }
  onYearSelected(value) {


    this.loadReportsTable(value.year);

  }

  loadReportsTable(year: any) {
    this.reportService.getAllReportsBasedOnYear$(year).subscribe((data: Report[]) => {
      //console.log(data);

      this.reportData = data;
      this.LoadTableFilters(data);

    });
  }

  getReportYears() {
    this.ReportYear = new ReportYear();
    this.ReportYear.year = new Date().getFullYear();

    var Years = new Array<ReportYear>();
    Years = [
      { id: 1, year: this.ReportYear.year },
      { id: 2, year: this.ReportYear.year - 1 },
      { id: 3, year: this.ReportYear.year - 2 }
    ];
    this.ReportYears = Years;
  }


  LoadTableFilters(reportData: Report[]) {
    this.reportNumbers = this.GetUniqueValues(reportData.map(r => r.reportNumber));
    this.reportNames = this.GetUniqueValues(reportData.map(r => r.reportName));
    this.countries = this.GetUniqueValues(reportData.map(r => r.country));
    this.fasPosts = this.GetUniqueValues(reportData.map(r => r.fasPost));
    this.distributionTypes = this.GetUniqueValues(reportData.map(r => r.distribution));
    this.reportStates = this.GetUniqueValues(reportData.map(r => r.reportState));
    this.reportTypes = this.GetUniqueValues(reportData.map(r => r.reportType));
  }
  GetUniqueValues(vals: any[]): SelectItem[] {
    var returnArry = new Array<SelectItem>();
    for (let cnt = 0; cnt < vals.length; cnt++) {
      if (returnArry.filter(r => r.label == vals[cnt]).length == 0)
        returnArry.push({ label: vals[cnt], value: vals[cnt] });
    }
    //console.log(returnArry.length);

    returnArry.sort(
      (a, b): number => {
        if (a.value < b.value) return -1;
        if (a.value > b.value) return 1;
        return 0;
      }
    );
    return returnArry;
  }
  loadReportStates(reportStateId: number) {
    this.lstReportStates = new Array<SelectItem>();
    this.lookupService.getReportStates$().subscribe((data: ReportState[]) => {
      data = data.filter(x => x.id !== ReportStates.NotStarted && x.id !== ReportStates.Hold && x.id !== ReportStates.Validated);
      this.allReportStates = data;
      data.forEach(element => {
        if (element.id !== reportStateId)
          this.lstReportStates.push({ label: element.stateName, value: element.id });
      });

    });
  }

  onClickChangeStatus(report) {
    this.displayStatusDlg = true;
    this.loadReportStates(report.reportStateId);
    this.reportId = report.id;
  }

  onClickViewHistory(report) {
    this.viewHistory.getReportHistory(report.id);
    this.displayHistoryDlg = true;
  }

  PublishImmediately(report) {
    this.reportDashboardService.getReportScheduleById(report.id).subscribe((data: ReportMetadata)=>{
          this.publishedReportMetadata = data;
              if(this.publishedReportMetadata.isReportPublished)
              {
                this.showPublishedReportClick = true;
                this.notifier.notify('error', 'Report is Published. Please refresh the page.');
              }
              else{
                  this.ShowConfirmationDlg(
                    report.id,
                    'Are you sure you want to Publish Immediately?',
                    'PublishImmediately',
                    'Report is send to Publish Immediately'
                  );
                }
    });
  }

  OnshowPublishedReportOkButton()
  {
    this.showPublishedReportClick = false;
  }

  ShowConfirmationDlg(id: any, dlgMessage: string, action: string, successMsg: string) {
    this.confirmationService.confirm({
      message: dlgMessage,
      header: 'Confirmation',
      icon: 'fa fa-exclamation-circle',
      key: 'Confirm',
      accept: () => {
        this.reportDashboardService.performAction$(id, action).subscribe(
          resp => {
            if (resp.ok) {
              //this.LoadReportSchedules();
              // this.refreshDataSource.emit(true);
              this.loadReportsTable(this.ReportYear.year);
              this.notifier.notify('success', successMsg);
            }
            // else {
            // this.notifier.notify('error', 'Report is already Published. Please refresh the page.');
            // }
          },
          err => {
            console.log(err);
            this.notifier.notify('error', 'Something went wrong, Please contact Administrator');
          }
        );
      }
    });
  }

  onClickCorrection(report) {
    this.ShowConfirmationDlg(
      report.id,
      'Are you sure you want to Request for correction?',
      'RequestCorrection',
      'Request for report correction has been sent'
    );

    // this.confirmationService.confirm({
    //   message: 'Are you sure you want to Request for correction?',
    //   header: 'Confirmation',
    //   icon: 'fa fa-exclamation-circle',
    //   accept: () => {
    //     this.reportService.updateReportState$(report.id, Number(ReportStates.RequestedForCorrection)).subscribe((resp) => {  //set stateID to request for correction
    //       if (resp.ok) {
    //           this.loadReportsTable(this.ReportYear.year);
    //           this.notifier.notify("success", "Request for report correction has been sent");
    //         }
    //         else {
    //           this.notifier.notify("error", "Failed to request for report correction");
    //         }

    //       });
    //     }

    // });
  }

  ShowAttachmentsDialog(id: any, reportState: string) {
    this.viewAttachment.ShowAttachmentsDialog(id, reportState);
    this.displayAttachmentDlg = true;
  }

  onClickReportInformation(report) {
    this.RptMetadata.showMetadataDialog(report);
  }

  onReportStatusChange() {
    //console.log(this.reportId +"," +this.selectedState);
    this.reportService.updateReportState$(this.reportId, this.selectedState).subscribe((resp) => {
      if (resp.ok) {
        this.notifier.notify("success", "Report State has been changed successfully");
        this.reportData = this.reportData.filter(x => x.id !== this.reportId);
        // this.reportData.forEach(element => {
        //   if(element.id === this.reportId)
        //   {
        //      this.lstReportStates.filter(item =>{
        //        console.log(item.label);
        //        if(item.value === this.selectedState)
        //            element.reportState= item.label;

        //      })
        //   }

        // });
        //this.loadReportStates(parseInt(this.selectedState.toString()));
      }
      else {
        this.notifier.notify("error", "Failed to change the Report state");
      }


    });
    this.displayStatusDlg = false;
  }
  onClose() {

    this.displayStatusDlg = false;
  }
  ShowHideDialog(isDisplay: boolean) {
    this.displayMetadata = isDisplay;
    // this.refreshDataSource.emit(true);
  }

  LaunchReport(report) {
    this.reportDashboardService.getReportScheduleById(report.id).subscribe((metadata:ReportSchedule)=>{
    this.reportScheduleforStatus = metadata;
    this.reportDashboardService.launchReport(report.id).subscribe(data => {
      const link = document.createElement('a');
      link.href = 'ms-word:ofe|u|' + environment.serverUrl + '/' + data;
      link.setAttribute('visibility', 'hidden');
      link.click();
      });
    });
  }
}
